import React from "react";


export const Card: React.FC<{}> = ({children}) => {
    return <div
        className="relative px-6 pt-10 pb-8 bg-white text-gray-500 shadow-md ring-1 ring-gray-900/5 sm:rounded-lg sm:px-10">
        {children}
    </div>
}